import { AlarmMaskingState } from "./types";

export function getDefaultState(): AlarmMaskingState {
	return {
		groupId: 0,
		responses: [],
		maxAlarmsToShow: 200,
		isAreaMaskingMode: false,
		isUpdatingArea: false,
	}
}
